import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mails-event',
  templateUrl: './mails-event.component.html',
  styleUrls: ['./mails-event.component.scss']
})
export class MailsEventComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  openCreateMail() {
    
  }

}
